<template>
  <div id="returnMgmt">
    <div class="header-box">
      <div class="header-line">
        <span class="header-label">时区</span>
        <el-select
          v-model="params.dsTimeZone"
          placeholder="请选择"
          size="small"
        >
          <el-option
            v-for="item in timeZoneOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <span class="header-label">日期</span>
        <el-date-picker
          v-model="date"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          size="small"
          value-format="yyyy-MM-dd"
          style="width: 230px"
        >
        </el-date-picker>
        <span class="header-label">退货物流单号</span>
        <el-input
          placeholder="请输入退货物流单号"
          size="small"
          clearable
          v-model="params.returnLogisticsOrderNo"
        >
        </el-input>

        <span class="header-label">操作人</span>
        <el-select
          placeholder="请选择"
          size="small"
          v-model="params.operateUserId"
        >
          <el-option
            v-for="item in operateUserOptions"
            :key="item.id"
            :label="item.nickname"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <span class="header-label">供应商名称</span>
        <el-select
          placeholder="请选择"
          size="small"
          v-model="params.supplierId"
        >
          <el-option
            v-for="item in supplierOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="header-line">
        <span class="header-label">退货状态</span>
        <el-select
          placeholder="请选择"
          size="small"
          v-model="params.returnAdjustStatus"
        >
          <el-option
            v-for="item in returnStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-button type="primary" size="small" v-on:click="queryReturnList"
          >查询</el-button
        >
      </div>
    </div>
    <el-table
      :data="tableData"
      :cell-class-name="setCellClass"
      :span-method="tableSpanMethod"
      border
      size="mini"
    >
      <el-table-column prop="createTime" label="创建日期" width="90px">
        <template v-slot="scope">
          <div v-if="scope.$index !== 0">
            {{ scope.row.createTime.split(" ")[0] }}
            <br />
            {{ scope.row.createTime.split(" ")[1] }}
          </div>
          <div v-else>合计</div>
        </template>
      </el-table-column>
      <el-table-column prop="supplierName" label="供应商名称" min-width="80px">
      </el-table-column>
      <el-table-column
        prop="returnLogisticsOrderNo"
        label="退货物流单号"
        min-width="80px"
      >
      </el-table-column>
      <el-table-column
        prop="returnLogisticsOrgTypeLabel"
        label="退货物流公司"
        min-width="80px"
      >
      </el-table-column>
      <el-table-column
        prop="totalReturnQuantity"
        label="退货数量"
        min-width="60px"
      >
      </el-table-column>
      <el-table-column
        prop="totalReturnAmount"
        label="退货金额"
        min-width="60px"
      >
      </el-table-column>
      <el-table-column
        prop="totalRefundQuantity"
        label="计划退款数量"
        min-width="60px"
      >
      </el-table-column>
      <el-table-column
        prop="totalRefundAmount"
        label="计划退款金额"
        min-width="80px"
      >
      </el-table-column>

      <el-table-column
        prop="totalExchangeQuantity"
        label="计划换货数量"
        min-width="60px"
      >
      </el-table-column>
      <el-table-column
        prop="totalExchangeAmount"
        label="计划换货金额"
        min-width="80px"
      >
      </el-table-column>
      <el-table-column
        prop="totalActualRefundAmount"
        label="实际退款金额"
        min-width="60px"
      >
      </el-table-column>
      <el-table-column
        prop="totalBadDebtAmount"
        label="坏账金额"
        min-width="80px"
      >
      </el-table-column>
      <el-table-column
        prop="returnAdjustStatusLabel"
        label="退货状态"
        min-width="80px"
      >
      </el-table-column>
      <el-table-column
        prop="operateUserNickname"
        label="操作人"
        min-width="80px"
      >
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="80px">
      </el-table-column>
      <el-table-column label="操作" min-width="80px">
        <template v-slot="scope">
          <el-button
            v-if="scope.row.returnAdjustStatus == 1"
            type="text"
            class="blue clickable"
            @click="editBtnClick(scope.row)"
          >
            编辑
          </el-button>
          <el-button
            v-else
            type="text"
            class="blue clickable"
            @click="detailBtnClick(scope.row)"
          >
            详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { returnModules } from "@r";
import { createNamespacedHelpers } from 'vuex'
const { 
  mapState: searchMapState,
  mapActions: searchMapActions, 
  mapGetters: searchMapGetters
} = createNamespacedHelpers('search');
const { 
  mapMutations: returnMapMutations
} = createNamespacedHelpers('returnModel');
export default {
  data() {
    return {
      date: [
        new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 365).format("yyyy-MM-dd"),
        new Date(new Date().getTime() + 1000 * 60 * 60 * 24).format("yyyy-MM-dd")
      ],
      params: {
        beginDate: "",
        endDate: "",
        returnLogisticsOrderNo: "",
        operateUserId: "",
        supplierId: "",
        returnAdjustStatus: "",
        dsTimeZone: 0,
        beginIndex: 0,
        pageSize: 20,
      },
      tableData: [],
    };
  },
  created() {
    this.getSupplierList();
    this.getOperateUserList();
    this.queryReturnList();
  },
  methods: {
    ...searchMapActions(['getSupplierList', 'getOperateUserList']),
    ...returnMapMutations(['setReturnMgmtList']),
    getQueryParams() {
      this.params.beginDate = this.date[0];
      this.params.endDate = this.date[1];
      return this.params;
    },
    queryReturnList() {
      let res = {
        "ldata":[
          {
            "createTime":"2020-10-30 13:55:10",
            "id":133,
            "operateUserId":10,
            "operateUserNickname":"文竹",
            "overOneMonth":0,
            "remark":"信丰物流，189202606346",
            "returnAdjustStatus":1,
            "returnAdjustStatusLabel":"退货中",
            "returnInboundRecordIdSet":[1714,1699,1674,1675],
            "returnLogisticsOrderNo":"1030-3",
            "returnLogisticsOrgType":17,
            "returnLogisticsOrgTypeLabel":"信丰物流",
            "supplierId":30,
            "supplierName":"深圳市维妮斯贸易有限公司",
            "totalActualRefundAmount":"0",
            "totalAmount":"0.00",
            "totalBadDebtAmount":"504.5",
            "totalExchangeAmount":"0",
            "totalExchangeQuantity":0,
            "totalQuantity":0,
            "totalRefundAmount":"504.5",
            "totalRefundQuantity":69,
            "totalReturnAmount":"504.5",
            "totalReturnQuantity":69
          },
          {
            "createTime":"2020-10-30 12:19:24",
            "id":132,
            "operateUserId":10,
            "operateUserNickname":"文竹",
            "overOneMonth":0,
            "remark":"信丰物流，189202606344",
            "returnAdjustStatus":1,
            "returnAdjustStatusLabel":"退货中",
            "returnInboundRecordIdSet":[1701,1672,1706,1740,1741,1679,1715,1716,1717,1718,1654,1719,1720,1721,1594],
            "returnLogisticsOrderNo":"1030-2",
            "returnLogisticsOrgType":17,
            "returnLogisticsOrgTypeLabel":"信丰物流",
            "supplierId":26,
            "supplierName":"汕头市潮南区陈店乐通数码电器商行",
            "totalActualRefundAmount":"0",
            "totalAmount":"0.00",
            "totalBadDebtAmount":"2748.5",
            "totalExchangeAmount":"0",
            "totalExchangeQuantity":0,
            "totalQuantity":0,
            "totalRefundAmount":"2748.5",
            "totalRefundQuantity":352,
            "totalReturnAmount":"2748.5",
            "totalReturnQuantity":352
          },
          {
            "createTime":"2020-10-30 11:43:40",
            "id":131,
            "operateUserId":10,
            "operateUserNickname":"文竹",
            "overOneMonth":0,
            "remark":"信丰物流，189202606345",
            "returnAdjustStatus":1,
            "returnAdjustStatusLabel":"退货中",
            "returnInboundRecordIdSet":[1712,1682,1730,1666,1731,1683,1606,1704,1705,1709,1629,1710],
            "returnLogisticsOrderNo":"1030-1",
            "returnLogisticsOrgType":17,
            "returnLogisticsOrgTypeLabel":"信丰物流",
            "supplierId":7,
            "supplierName":"深圳市福田区卡烨塘通讯产品商行",
            "totalActualRefundAmount":"0",
            "totalAmount":"0.00",
            "totalBadDebtAmount":"3962",
            "totalExchangeAmount":"0",
            "totalExchangeQuantity":0,
            "totalQuantity":0,
            "totalRefundAmount":"3962",
            "totalRefundQuantity":551,
            "totalReturnAmount":"3962",
            "totalReturnQuantity":551
          },
          {
            "createTime":"2020-10-26 16:02:14",
            "id":130,
            "operateUserId":10,
            "operateUserNickname":"文竹",
            "overOneMonth":0,
            "remark":"信丰物流，189202606344",
            "returnAdjustStatus":1,
            "returnAdjustStatusLabel":"退货中",
            "returnInboundRecordIdSet":[1667,1668,1669,1671,1609,1610,1612,1676,1677,1553,1618,1620,1685,1625,1626,1695,1632,1633,1635,1637,1638,1639,1640,1641,1642,1643,1653,1655,1592,1656,1657,1658,1595,1659],
            "returnLogisticsOrderNo":"1026-1",
            "returnLogisticsOrgType":8,
            "returnLogisticsOrgTypeLabel":"优速快递",
            "supplierId":26,
            "supplierName":"汕头市潮南区陈店乐通数码电器商行",
            "totalActualRefundAmount":"0",
            "totalAmount":"0.00",
            "totalBadDebtAmount":"4509.5",
            "totalExchangeAmount":"0",
            "totalExchangeQuantity":0,
            "totalQuantity":0,
            "totalRefundAmount":"4509.5",
            "totalRefundQuantity":658,
            "totalReturnAmount":"4509.5",
            "totalReturnQuantity":658
          },
          {
            "createTime":"2020-10-23 17:03:52",
            "id":129,
            "operateUserId":10,
            "operateUserNickname":"文竹",
            "overOneMonth":0,
            "remark":"信丰物流，189202606344",
            "returnAdjustStatus":1,
            "returnAdjustStatusLabel":"退货中",
            "returnInboundRecordIdSet":[1552,1619,1670,1510,1593,1692,1644,1630,1551],
            "returnLogisticsOrderNo":"1023-3-1",
            "returnLogisticsOrgType":8,
            "returnLogisticsOrgTypeLabel":"优速快递",
            "supplierId":26,
            "supplierName":"汕头市潮南区陈店乐通数码电器商行",
            "totalActualRefundAmount":"0",
            "totalAmount":"0.00",
            "totalBadDebtAmount":"3210.5",
            "totalExchangeAmount":"0",
            "totalExchangeQuantity":0,
            "totalQuantity":0,
            "totalRefundAmount":"3210.5",
            "totalRefundQuantity":392,
            "totalReturnAmount":"3210.5",
            "totalReturnQuantity":392
          },
          {
            "createTime":"2020-10-23 16:55:56",
            "id":128,
            "operateUserId":10,
            "operateUserNickname":"文竹",
            "overOneMonth":0,
            "remark":"信丰物流，189202606345",
            "returnAdjustStatus":1,
            "returnAdjustStatusLabel":"退货中",
            "returnInboundRecordIdSet":[1665,1508,1607,1579,1580,1582,1550,1615,1583,1584,1648,1586,1588,1589,1622,1559,1693,1470],
            "returnLogisticsOrderNo":"1023-2",
            "returnLogisticsOrgType":8,
            "returnLogisticsOrgTypeLabel":"优速快递",
            "supplierId":7,
            "supplierName":"深圳市福田区卡烨塘通讯产品商行",
            "totalActualRefundAmount":"0",
            "totalAmount":"0.00",
            "totalBadDebtAmount":"1471.85",
            "totalExchangeAmount":"0",
            "totalExchangeQuantity":0,
            "totalQuantity":0,
            "totalRefundAmount":"1471.85",
            "totalRefundQuantity":164,
            "totalReturnAmount":"1471.85",
            "totalReturnQuantity":164
          },
          {
            "createTime":"2020-10-23 16:34:19",
            "id":127,
            "operateUserId":10,
            "operateUserNickname":"文竹",
            "overOneMonth":0,
            "remark":"信丰物流，189202606346",
            "returnAdjustStatus":1,
            "returnAdjustStatusLabel":"退货中",
            "returnInboundRecordIdSet":[1616,1651,1652,1623,1624,1596,1645,1597,1598,1646],
            "returnLogisticsOrderNo":"1023-1",
            "returnLogisticsOrgType":8,
            "returnLogisticsOrgTypeLabel":"优速快递",
            "supplierId":30,
            "supplierName":"深圳市维妮斯贸易有限公司",
            "totalActualRefundAmount":"0",
            "totalAmount":"0.00",
            "totalBadDebtAmount":"1971.1",
            "totalExchangeAmount":"0",
            "totalExchangeQuantity":0,
            "totalQuantity":0,
            "totalRefundAmount":"1971.1",
            "totalRefundQuantity":250,
            "totalReturnAmount":"1971.1",
            "totalReturnQuantity":250
          },
          {
            "createTime":"2020-10-19 18:06:23",
            "id":126,
            "operateUserId":10,
            "operateUserNickname":"文竹",
            "overOneMonth":0,
            "remark":"优速快递，900801026341",
            "returnAdjustStatus":2,
            "returnAdjustStatusLabel":"退货成功",
            "returnInboundRecordIdSet":[1533,1311],
            "returnLogisticsOrderNo":"66",
            "returnLogisticsOrgType":8,
            "returnLogisticsOrgTypeLabel":"优速快递",
            "supplierId":94,
            "supplierName":"义乌市明尚工艺品厂",
            "totalActualRefundAmount":"0",
            "totalAmount":"0.00",
            "totalBadDebtAmount":"0",
            "totalExchangeAmount":"404.95",
            "totalExchangeQuantity":91,
            "totalQuantity":0,
            "totalRefundAmount":"0",
            "totalRefundQuantity":0,
            "totalReturnAmount":"404.95",
            "totalReturnQuantity":91
          },
          {
            "createTime":"2020-10-19 18:05:51",
            "id":125,
            "operateUserId":10,
            "operateUserNickname":"文竹",
            "overOneMonth":0,
            "remark":"优速快递，900801028643",
            "returnAdjustStatus":1,
            "returnAdjustStatusLabel":"退货中",
            "returnInboundRecordIdSet":[1601,1549],
            "returnLogisticsOrderNo":"55",
            "returnLogisticsOrgType":8,
            "returnLogisticsOrgTypeLabel":"优速快递",
            "supplierId":68,
            "supplierName":"广州市鑫时彩塑胶制品有限公司",
            "totalActualRefundAmount":"0",
            "totalAmount":"0.00",
            "totalBadDebtAmount":"35.1",
            "totalExchangeAmount":"390",
            "totalExchangeQuantity":100,
            "totalQuantity":0,
            "totalRefundAmount":"35.1",
            "totalRefundQuantity":9,
            "totalReturnAmount":"425.1",
            "totalReturnQuantity":109
          },
          {
            "createTime":"2020-10-19 18:05:14",
            "id":124,
            "operateUserId":10,
            "operateUserNickname":"文竹",
            "overOneMonth":0,
            "remark":"优速快递，900801027823",
            "returnAdjustStatus":1,
            "returnAdjustStatusLabel":"退货中",
            "returnInboundRecordIdSet":[1408,1409,1410,1411,1412,1413,1414,1415,1418,1419,1420,1421,1423,1424],
            "returnLogisticsOrderNo":"44",
            "returnLogisticsOrgType":8,
            "returnLogisticsOrgTypeLabel":"优速快递",
            "supplierId":98,
            "supplierName":"深圳市品成科技有限公司",
            "totalActualRefundAmount":"0",
            "totalAmount":"0.00",
            "totalBadDebtAmount":"0",
            "totalExchangeAmount":"214.5",
            "totalExchangeQuantity":143,
            "totalQuantity":0,
            "totalRefundAmount":"0",
            "totalRefundQuantity":0,
            "totalReturnAmount":"214.5",
            "totalReturnQuantity":143
          },
          {
            "createTime":"2020-10-15 16:09:20",
            "id":123,
            "operateUserId":10,
            "operateUserNickname":"文竹",
            "overOneMonth":0,
            "remark":"优速快递，900801030432",
            "returnAdjustStatus":1,
            "returnAdjustStatusLabel":"退货中",
            "returnInboundRecordIdSet":[1536,1429,1541,1542,1494,1495,1209,1498,1547,1531,1452],
            "returnLogisticsOrderNo":"33",
            "returnLogisticsOrgType":8,
            "returnLogisticsOrgTypeLabel":"优速快递",
            "supplierId":83,
            "supplierName":"义乌市融玛电子商务商行",
            "totalActualRefundAmount":"0",
            "totalAmount":"0.00",
            "totalBadDebtAmount":"1423.7",
            "totalExchangeAmount":"220.72",
            "totalExchangeQuantity":124,
            "totalQuantity":0,
            "totalRefundAmount":"1423.7",
            "totalRefundQuantity":182,
            "totalReturnAmount":"1644.42",
            "totalReturnQuantity":306
          },
          {
            "createTime":"2020-10-15 16:02:41",
            "id":122,
            "operateUserId":10,
            "operateUserNickname":"文竹",
            "overOneMonth":0,
            "remark":"优速快递，900801029768",
            "returnAdjustStatus":1,
            "returnAdjustStatusLabel":"退货中",
            "returnInboundRecordIdSet":[1475,1476,1477,1478,1448,1449,1514,1517,1422,1518,1486,1520,1521,1428,1469,1471],
            "returnLogisticsOrderNo":"22",
            "returnLogisticsOrgType":8,
            "returnLogisticsOrgTypeLabel":"优速快递",
            "supplierId":7,
            "supplierName":"深圳市福田区卡烨塘通讯产品商行",
            "totalActualRefundAmount":"0",
            "totalAmount":"0.00",
            "totalBadDebtAmount":"0",
            "totalExchangeAmount":"1660.5",
            "totalExchangeQuantity":211,
            "totalQuantity":0,
            "totalRefundAmount":"0",
            "totalRefundQuantity":0,
            "totalReturnAmount":"1660.5",
            "totalReturnQuantity":211
          },
          {
            "createTime":"2020-10-15 15:51:15",
            "id":121,
            "operateUserId":10,
            "operateUserNickname":"文竹",
            "overOneMonth":0,
            "remark":"优速快递，900801038589",
            "returnAdjustStatus":1,
            "returnAdjustStatusLabel":"退货中",
            "returnInboundRecordIdSet":[1540,1480,1481,1482,1483,1484,1485,1427,1434,1562,1436,1565,1438,1569,1441,1442,1443,1572,1509,1573,1446,1574,1575,1511,1577,1578,1453,1455,1456,1458,1459,1460,1397,1461,1525,1462,1526,1591,1463,1528,1464,1467],
            "returnLogisticsOrderNo":"11",
            "returnLogisticsOrgType":8,
            "returnLogisticsOrgTypeLabel":"优速快递",
            "supplierId":26,
            "supplierName":"汕头市潮南区陈店乐通数码电器商行",
            "totalActualRefundAmount":"0",
            "totalAmount":"0.00",
            "totalBadDebtAmount":"718",
            "totalExchangeAmount":"3627.1",
            "totalExchangeQuantity":470,
            "totalQuantity":0,
            "totalRefundAmount":"718",
            "totalRefundQuantity":102,
            "totalReturnAmount":"4345.1",
            "totalReturnQuantity":572
          }
        ],
        "mdata":{
          "totalReturnQuantitySum":3868,
          "totalExchangeAmountSum":"6517.77",
          "totalActualRefundAmountSum":"0",
          "totalRefundQuantitySum":2729,
          "totalBadDebtAmountSum":"20554.75",
          "totalExchangeQuantitySum":1139,
          "totalReturnAmountSum":"0",
          "totalRefundAmountSum":"20554.75"
        },
        "message":"",
        "result":1
      };
      // returnModules.list(this.getQueryParams()).then((res) => {
        this.setReturnMgmtList(res.ldata);
        res.ldata.unshift({
          "totalReturnQuantity": res.mdata.totalReturnQuantitySum,
          "totalExchangeAmount": res.mdata.totalExchangeAmountSum,
          "totalActualRefundAmount": res.mdata.totalActualRefundAmountSum,
          "totalRefundQuantity": res.mdata.totalRefundQuantitySum,
          "totalBadDebtAmount": res.mdata.totalBadDebtAmountSum,
          "totalExchangeQuantity": res.mdata.totalExchangeQuantitySum,
          "totalReturnAmount": res.mdata.totalReturnAmountSum,
          "totalRefundAmount": res.mdata.totalRefundAmountSum
        });
        this.tableData = res.ldata;
      // });
    },
    editBtnClick(row) {
      this.$router.push({
        path: "/client/exchangeRefund",
        query: { id: row.id, operateType: 1 },
      });
    },
    detailBtnClick(row) {
      this.$router.push({
        path: "/client/exchangeRefund",
        query: { id: row.id, operateType: 2 },
      });
    },
    setCellClass({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 12) {
        if (row.returnAdjustStatus === 1 && row.overOneMonth === 1) {
          return "red-text";
        }
      }
    },
    tableSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        if ([0, 12].includes(columnIndex)) {
          return [1, 4];
        }
        if ([1, 2, 3, 13, 14, 15].includes(columnIndex)) {
          return [1, 0];
        }
        return [1, 1];
      }
    }
  },
  computed: {
    ...searchMapState({
      'pickerOptions': (state) => {
        return state.pickerOptions;
      },
      'timeZoneOptions': (state) => {
        return state.timeZoneOptions;
      },
      'returnStatusOptions': (state) => {
        return state.returnStatusOptions;
      },
    }),
    ...searchMapGetters({
      'supplierOptions': 'allSupplierList',
      'operateUserOptions': 'allOperateUserList'
    })
  }
};
</script>

<style v-slot='scope' lang='scss'>
.red-text {
  color: red;
}
</style>
